<script lang="ts">
  import Caret from "~icons/ph/caret-down";
</script>

<details>
  <summary>Does this mean the case is over?<Caret /></summary>
  <p>
    Yes, the settlement is full and final for all of your Claims against easyJet as a result of this cyber-attack. This
    means you must not bring your Claim or any other claim against easyJet in relation to the cyber-attack. Please note
    that, if you fail to keep to these obligations, easyJet may be entitled to take legal action against you.
  </p>
</details>
